export function upButton() {
  const px_change = 200;
  const target = document.querySelector('#c-button__up');
  target.classList.add('is-inactive');
  window.addEventListener('scroll', function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const target = document.querySelector('#c-button__up');
    if (scrollTop > px_change) {
      target.classList.add('is-active');
      target.classList.remove('is-inactive');
    } else {
      target.classList.add('is-inactive');
      target.classList.remove('is-active');
    }
  });
  window.addEventListener('scroll', function () {
    if (document.querySelector('#content__contact')) {
      const bodyHeight = document.body.clientHeight;
      const windowHeight = window.innerHeight;
      const bottomPoint = bodyHeight - windowHeight;
      const currentPos = window.pageYOffset;
      if (bottomPoint <= currentPos) {
        target.classList.add('is-bottom');
      } else {
        target.classList.remove('is-bottom');
      }
    }
  });
  scrollTop('c-button__up', 500);
  function scrollTop(elem, duration) {
    const target = document.getElementById(elem);
    target.addEventListener('click', function () {
      let currentY = window.pageYOffset;
      let step = duration / currentY > 1 ? 10 : 100;
      let timeStep = (duration / currentY) * step;
      let intervalID = setInterval(scrollUp, timeStep);
      function scrollUp() {
        currentY = window.pageYOffset;
        if (currentY === 0) {
          clearInterval(intervalID);
        } else {
          scrollBy(0, -step);
        }
      }
    });
  }
}
